import { useEffect, useState } from 'react';
import formatDate from '../../../helpers/format-date';
import IconEdit from '../../icons/edit';
import Textarea from '../../textarea/textarea';
import ButtonSecondary from '../../button/button-secondary';
import { ButtonSize } from '../../button/types';
import IconLoader from '../../icons/loader';
import IconTrash from '../../icons/trash';
import { DocumentCommenTypes } from './types';

import styles from './documents.module.css';

export default function DocumentComment({
  comment,
  documentId,
  editComment,
  editCommentInProgress,
  editCommentIsSuccess,
  deleteComment,
  deleteCommentInProgress,
  setCommentId,
  commentsVisible,
}: DocumentCommenTypes) {
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(comment.text);

  useEffect(() => {
    if (comment) {
      setText(comment.text);
    }
  }, [comment]);

  useEffect(() => {
    if (editCommentIsSuccess) {
      setEdit(false);
    }
  }, [editCommentIsSuccess]);

  let content;

  if (!edit) {
    content = (
      <div className={styles.documentSidepanelComment}>
        <div className={styles.documentSidepanelCommentTop}>
          <div className={styles.documentSidepanelCommentTopLeft}>
            <div>{`${comment?.user?.profile?.firstName} ${comment?.user?.profile?.lastName}`}</div>
            <div>
              {`${
                comment.updatedAt !== comment.createdAt ? 'updated at' : ''
              } ${formatDate(
                comment.updatedAt !== comment.createdAt
                  ? comment.updatedAt
                  : comment.createdAt,
                true,
              )}`}
            </div>
          </div>
          {commentsVisible && (
            <div className={styles.documentSidepanelCommentTopRight}>
              <button
                type="button"
                className={styles.documentEditButton}
                onClick={() => setEdit(true)}
                aria-label="Edit button"
              >
                <IconEdit width={16} height={16} />
              </button>
              <button
                type="button"
                className={styles.documentDeleteButton}
                aria-label="Delete button"
                onClick={() => {
                  setCommentId(comment.id);

                  if (deleteComment) {
                    deleteComment({
                      id: documentId as string,
                      commentId: comment.id,
                    });
                  }
                }}
              >
                {deleteCommentInProgress ? (
                  <IconLoader width={16} height={16} />
                ) : (
                  <IconTrash width={16} height={16} />
                )}
              </button>
            </div>
          )}
        </div>
        <div className={styles.documentSidepanelCommentText}>
          {comment.text}
        </div>
      </div>
    );
  } else {
    content = (
      <div className={styles.documentEditWrapper}>
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          name="text"
          className={styles.documentEditTextarea}
          placeholder="Comment text..."
        />
        <div className={styles.documentEditControls}>
          <ButtonSecondary
            className={`button-white ${styles.documentEditSubmit}`}
            disabled={!text || editCommentInProgress}
            onClick={() => {
              setText('');
              if (editComment) {
                editComment({
                  id: documentId as string,
                  commentId: comment.id,
                  body: {
                    text,
                  },
                });
              }
            }}
            text={editCommentInProgress ? 'Loading...' : 'Edit'}
            size={ButtonSize.SMALL}
          />
          <ButtonSecondary
            className={`button-white ${styles.documentEditSubmit}`}
            onClick={() => setEdit(false)}
            text="Cancel"
            size={ButtonSize.SMALL}
          />
        </div>
      </div>
    );
  }

  return content;
}
